import { Where, IFilter } from 'types/common'
import { ITheme, IThemeWithRelations } from 'interfaces/theme'
import { createCrudService } from '../crud'

const themeCrudService = createCrudService<ITheme, IThemeWithRelations>('themes')

export const createTheme = (data: ITheme): Promise<IThemeWithRelations> => {
  return themeCrudService.create(data)
}

export const countTheme = (where: Where<ITheme> = {}): Promise<number> => {
  return themeCrudService.count(where)
}

export const getThemes = (filter: IFilter<ITheme>): Promise<IThemeWithRelations[]> => {
  return themeCrudService.get(filter)
}

export const getThemeDetail = (id: number, filter: IFilter<ITheme>): Promise<IThemeWithRelations> => {
  return themeCrudService.getDetail(id, filter)
}

export const updateTheme = (id: number, data: ITheme): Promise<ITheme> => {
  return themeCrudService.update(id, data)
}

export const deleteTheme = (id: number): Promise<void> => {
  return themeCrudService.delete(id)
}
